/**
 * Get Webpack runtime context form current JavaScript scope.
 *
 * __You likely don't need to use it.__
 */ Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getWebpackContext", {
    enumerable: true,
    get: function() {
        return getWebpackContext;
    }
});
function getWebpackContext() {
    return __webpack_require__;
}
